var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 10.7031L10.8555 10.3203C11.1562 10.9492 11.5664 11.5234 12.0586 11.9883C12.9883 10.8398 13.5352 9.36328 13.5352 7.75C13.5352 6.16406 12.9883 4.6875 12.0586 3.53906C11.5664 4.00391 11.1836 4.55078 10.8828 5.15234L10.0898 4.76953C10.4453 4.05859 10.9102 3.42969 11.4844 2.88281C10.2539 1.70703 8.61328 0.96875 6.78125 0.96875C4.94922 0.96875 3.28125 1.70703 2.05078 2.88281C2.625 3.42969 3.08984 4.05859 3.44531 4.76953L2.65234 5.15234C2.35156 4.55078 1.96875 4.00391 1.47656 3.53906C0.546875 4.6875 0 6.16406 0 7.75C0 9.36328 0.546875 10.8398 1.47656 11.9883C1.96875 11.4961 2.37891 10.9492 2.67969 10.3203L3.47266 10.7031C3.11719 11.4414 2.65234 12.0703 2.07812 12.6445C3.28125 13.8203 4.94922 14.5312 6.78125 14.5312C8.58594 14.5312 10.2539 13.8203 11.457 12.6445C10.8828 12.0977 10.418 11.4414 10.0625 10.7031ZM3.82812 9.82812L2.98047 9.58203C3.39062 8.29688 3.33594 7.01172 2.98047 5.91797L3.80078 5.64453C4.21094 6.875 4.29297 8.35156 3.82812 9.82812ZM9.73438 5.64453L10.5547 5.91797C10.1992 7.01172 10.1445 8.29688 10.5547 9.58203L9.70703 9.85547C9.24219 8.37891 9.32422 6.875 9.73438 5.64453Z",
    fill: "#A21D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.102969d6567e318288effc943f3e3db3.svg";
export { ForwardRef as ReactComponent };